import CommonWindowApp from './CommonWindowApp'
import vuetify from '@/pages/home/plugins/vuetify';

/**
 * 도우미 플러그인
 *
 * [사용법]
 * 1. alert
 *      this.$window.alert('안녕하세요')
 *      .then(() => {
 *          // alert 창이 닫힐 때 처리할 코드
 *      })
 *
 *      this.$window.alert('안녕하세요.', 'success', 2000);
 *      params:
 *          - message: String
 *          - type: String ('success' | 'info' | 'warn' | 'error'. default: 'success')
 *          - timeout: Number (default: 2000)
 *
 *
 * 2. confirm
 *      this.$window.confirm('진행할까요?')
 *      .then(() => {
 *          // 확인시 처리할 코드
 *      })
 *      .catch(() => {
 *          // 취소시 처리할 코드
 *      })
 *
 * 3. prompt
 *      this.$window.prompt('당신의 이름은?')
 *      .then((value) => {
 *          // 확인시 처리할 코드
 *      })
 *      .catch((value) => {
 *          // 취소시 처리할 코드
 *      })
 *
 * 4. loading
 *      this.$window.showLoading("대기중");
 *      this.$window.hideLoading();
 *
 */
class CommonWindow {
    install (Vue) {
        const _app = document.createElement('div');
        _app.setAttribute('id', 'commonWindowApp');
        document.body.append(_app);

        const vm = new Vue({
            vuetify,
            render: h => h(CommonWindowApp),
        }).$mount('#commonWindowApp');

        const rootComponent = vm.$children[0];

        Vue.prototype.$window = {
            helper: rootComponent,

            alert(message, type= 'success', timeout= 2000) {
                // if (type === 'error') console.error(message);

                return this.helper.alert(message, type, timeout);
            },

            confirm(message) {
                return this.helper.confirm(message);
            },

            prompt(message, required = false, label = '값') {
                return this.helper.prompt(message, required, label);
            },

            showLoading(message=null) {
                this.helper.loading(true, message);
            },

            hideLoading() {
                this.helper.loading(false);
            }
        }
    }
}

const commonWindow = new CommonWindow();

export default commonWindow;